import { useMemo } from "react";
import CatWithChildren from "./CatWithChildren";

function hasActiveChild(children, active_id) {
  if (!children?.length) {
    return false;
  }
  for (const child of children) {
    if (child?.term_id == active_id) {
      return true;
    }
    if (child?.children?.length > 0) {
      const has_active_child = hasActiveChild(child?.children, active_id);
      if (has_active_child) {
        return true;
      }
    }
  }
  return false;
}

export function isActiveCategoryWithChild(cat, active_id) {
  if (cat?.term_id == active_id) {
    return true;
  }

  const is_active = hasActiveChild(cat?.children, active_id);
  return is_active;
}

const CategoryFilters = ({ categories, active_id }) => {
  const filterCategories = useMemo(() => {
    if (categories?.length === 0) {
      return [];
    }

    const currentCategory = categories.find(cat => parseInt(cat?.term_id) === parseInt(active_id)) || null;
    const children = categories.filter(cat => parseInt(cat?.parent_category) === parseInt(active_id));
    const neighbours = categories.filter(cat => parseInt(cat.parent_category) === parseInt(currentCategory?.parent_category) && parseInt(cat?.term_id) !== parseInt(active_id));
    const allParentCats = categories.filter(cat => cat?.parent_category === "0");

    // A list of all parent categories
    const parents = [];
    let parentId = currentCategory?.parent_category;
    while (parentId !== "0") {
      const parentCategory = categories.find(cat => parseInt(cat.term_id) === parseInt(parentId));
      if (parentCategory) {
        parents.push(parentCategory);
        parentId = parentCategory.parent_category;
      } else {
        break;
      }
    }

    parents.reverse();

    // Create a nested structure of categories
    const nestedCategories = [parents.reduceRight((acc, parent) => {
      const sortedChildren = (acc ? [acc, ...(parent?.term_id === currentCategory?.parent_category ? neighbours : [])] : neighbours)
        .sort((a, b) => a?.custom_order - b?.custom_order);

      return {
        ...parent,
        children: sortedChildren
      };
    }, { ...currentCategory, children })];

    // Add all parent categories if no active category
    if (!currentCategory) {
      return allParentCats?.sort((a, b) => a?.custom_order - b?.custom_order) || [];
    }

    // If the current category is a parent category, add its sibling parent categories
    if (currentCategory?.parent_category === "0") {
      const otherParentCategories = categories.filter(cat => cat?.parent_category === "0" && parseInt(cat?.term_id) !== parseInt(currentCategory?.term_id));
      const newArrCats = [...nestedCategories, ...otherParentCategories].sort((a, b) => a?.custom_order - b?.custom_order) || [];

      return newArrCats;
    }

    return nestedCategories.sort((a, b) => a?.custom_order - b?.custom_order) || [];
  }, [active_id]);

  return (
    <div className="px-3 py-4 border-2 rounded-10 border-[#E8E8EB] h-fit">
      <span className="px-3 text-base font-bold text-dark-text">Categorieën</span>
      <ul className="mt-4 text-dark-text">
        {filterCategories?.map((cat, idx) => {
          const active = isActiveCategoryWithChild(cat, active_id);

          return (
            <CatWithChildren
              key={idx}
              cat={cat}
              main_active={active}
              active_id={active_id}
              is_main
            />
          );
        })}
      </ul>
    </div>
  );
};

export default CategoryFilters;
